import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = { slots: null };

export const useSiteImages = () => {
  const [slots, setSlots] = useState(cache.slots);
  useEffect(() => {
    if (cache.slots) return;
    let alive = true;
    api
      .get("/site-images")
      .then((r) => {
        if (!alive) return;
        cache.slots = r.data || {};
        setSlots(cache.slots);
      })
      .catch(() => {
        if (!alive) return;
        cache.slots = {};
        setSlots(cache.slots);
      });
    return () => {
      alive = false;
    };
  }, []);
  const img = (key, fallback) => (slots === null ? null : slots[key] || fallback);
  img.ready = slots !== null;
  return img;
};
